import NewQuestion from "model/admin/NewQuestion";
import Competition from "model/Competition";
import {API_URL} from "common/const";
import {fetchApiClient} from "common/fetchApiClient";
import { AxiosError } from "axios";
import UnauthorizedError from "api/errors/UnauthorizedError";


const addQuestion = async (competition: Competition, question: NewQuestion, token: string | undefined): Promise<void> => {
    const apiClient = fetchApiClient(token);

    await apiClient.put(`${API_URL}/questions/${competition.code}`, {
        question: question
    }).catch((error: AxiosError) => {
        console.log(`Error adding question to Competition(${competition})`, question, error);
        if (!!error.response && error.response.status === 403) {
            throw new UnauthorizedError();
        }
        throw error;
    });
}

export default addQuestion;
